import { Icon } from "@iconify/react/dist/iconify.js";
import { useTranslation } from "react-i18next";
import "./style.css";
import TextBox from "../../../shared/TextBox/TextBox";
import Badge from "../../../shared/Badge/Badge";
import ScreenHeader from "@/components/ScreenHeader";
import Card from "../../../shared/Card/Card";

const ClinicalSubmission = ({ data }) => {
  const { t } = useTranslation();
  const { price, availableFromDate, availableToDate, isVerifiedProvider, packages, providerRemarks } = data || {};

  const availabilityWindow = `${availableFromDate?.slice(0, 10)} - ${availableToDate?.slice(0, 10)}`;
  const bidPrice = price;
  const serviceInclusions = packages;

  const fmt = (n) => `$${Number(n).toLocaleString("en-US", { minimumFractionDigits: 2 })}`;

  return (
    <div className="cs-card ">
      <div className="cs-title-row">
        <ScreenHeader title={t("clinical-financial-submission")} className="bg-transparent m-0 p-0" />
        {isVerifiedProvider && (
          <Badge
            icon="solar:shield-check-bold"
            title= {t("verified-provider")}
            className="cs-verified-badge"
          />
        )}
      </div>

      <div className="cs-panels">
        <Card className="cs-panel" title={t("proposed-clinical-fee")} value={fmt(bidPrice)} />
        <Card className="cs-panel" title={t("availability-window")} value={availabilityWindow} />
      </div>
      <div className="cs-inclusions">
        <p className="cs-section-label">{t("service-inclusions-hospital-side")}</p>
        <div className="cs-inclusions-grid">
          {serviceInclusions?.map((item, i) => (
            <div className="cs-inclusion-item" key={i}>
              <span className="cs-bullet" />
              {item}
            </div>
          ))}
        </div>
      </div>

      <div className="cs-remarks">
        <p className="cs-section-label">{t("providers-internal-remarks")}</p>
        <TextBox
          text={providerRemarks}
          className="w-100 p-0"
          textBoxClassName="p-2"
        />
      </div>
    </div>
  );
};

export default ClinicalSubmission;
